import React, { useEffect } from "react";
import DoctorAnalyticsData from "../components/DoctorAnalyticsData";
import { decoded } from "../Utils/UserProfile";
import { useNavigate } from "react-router";

const DoctorAnalytics = () => {
  const navigate = useNavigate();
  useEffect(() => {
    if (decoded === null) {
      window.location.href = "/";
    }
  }, [decoded]);
  return (
    <div className="innerContainer">
      <div className="dashboardPage">
        <DoctorAnalyticsData />
      </div>
    </div>
  );
};

export default DoctorAnalytics;
